export const timezoneOptions = {
  "America/New_York": "EST",
  "America/Chicago": "CST",
  "America/Denver": "MTN",
  "America/Los_Angeles": "PST",
};
